// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorToast-module__wrapper--bde64","link":"ErrorToast-module__link--a7126"};